import qs from 'query-string'

// TODO: Use the below instead when the following TS issues are fixed:
// - https://github.com/microsoft/TypeScript/issues/15300
// - https://github.com/microsoft/TypeScript/issues/42021
// Context: https://github.com/sindresorhus/query-string/issues/298
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StringifiableRecord = Record<string, any>

export const queryStringify = <Params extends StringifiableRecord>(params: Params, options?: qs.StringifyOptions | undefined) => {
  const stringifiedValues: StringifiableRecord = {}
  const keys = Object.keys(params)
  for (const key of keys) {
    const value = params[key]
    if (value !== null && typeof value === 'object') {
      stringifiedValues[key] = JSON.stringify(value)
    }
    else {
      stringifiedValues[key] = value
    }
  }
  return qs.stringify(stringifiedValues, options)
}
